import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { getFormattedDate, TIME_FORMAT_12H_SHORT } from 'dateUtils';

export default function useActionOnAtCopy() {
  const { t } = useTranslation();

  return useCallback(
    (translationKey: string, date: Date | string) =>
      t(translationKey, {
        date: getFormattedDate(new Date(date)),
        time: getFormattedDate(new Date(date), TIME_FORMAT_12H_SHORT),
      }),
    [t],
  );
}
